export default "__VITE_ASSET__DS_P6sIX__"